@if (allocationData) {
  <div class="pb-5">
    <form #productForm="ngForm" (ngSubmit)="saveAlloaction()">

      <!-- Title -->
      <app-cards-basic title="{{ 'COMMON.title' | translate }}">
        @for (lang of _languageService.supportedLangs; track lang) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>{{ 'COMMON.title_' + lang | translate }}</mat-label>
            <input matInput
                   required
                   [(ngModel)]="allocationData.translations[lang].title"
                   name="productTitle_{{ lang }}">
          </mat-form-field>
        }
      </app-cards-basic>

      <!-- Datenverknüpfung -->
      <app-cards-basic title="Datenverknüpfung">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>File Url</mat-label>
          <input matInput
                 [(ngModel)]="allocationData.file_url"
                 name="file_url">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Sheet Name</mat-label>
          <input matInput
                 [(ngModel)]="allocationData.excel_sheet_name"
                 name="excel_sheet_name">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Field Product ID</mat-label>
          <input matInput
                 [(ngModel)]="allocationData.file_product_id"
                 name="file_product_id">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Field Category</mat-label>
          <input matInput
                 [(ngModel)]="allocationData.file_category"
                 name="file_category">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Field Type</mat-label>
          <input matInput
                 [(ngModel)]="allocationData.file_type"
                 name="file_type">
        </mat-form-field>
        <button mat-flat-button
                color="primary"
                type="button"
                (click)="importAllocationFromUrl()"
                class="bp-button">
          Import from Url
        </button>
      </app-cards-basic>


    </form>


    <!-- Actions -->
    <button mat-button
            color="primary"
            type="button"
            (click)="cancel()"
            class="bp-button">
      {{ 'ACTIONS.cancel' | translate }}
    </button>
    <button mat-flat-button
            color="primary"
            [disabled]="!productForm.valid"
            (click)="saveAlloaction()"
            class="bp-button">
      {{ 'ACTIONS.save' | translate }}
    </button>
  </div>
}
